module.exports = __webpack_public_path__ + "img/institutions.cecd2acf.webp";